import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";

interface ComingSoonToastOptions {
  isLight: boolean;
  show: boolean;
  trd: (text: string) => string;
}

export function comingSoonToastPortal(
  { isLight, show, trd }: ComingSoonToastOptions,
  container: Parameters<typeof createPortal>[1] | null =
    typeof document !== "undefined" ? document.body : null,
): ReturnType<typeof createPortal> | null {
  if (!container) return null;
  return createPortal(
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.3 }}
          className="fixed top-6 left-0 right-0 z-[9999] flex justify-center px-4"
        >
          <div
            className="px-6 py-3 rounded-xl shadow-lg flex items-center gap-3 whitespace-nowrap"
            style={{
              background: isLight ? "#1c1c1e" : "#ffffff",
              color: isLight ? "#ffffff" : "#1c1c1e",
            }}
          >
            <i className="ri-time-line text-lg" />
            <span className="text-sm font-medium">{trd("即將上線，敬請期待")}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    container,
  );
}